import React, { useEffect } from "react";
import { string } from "prop-types";
import Alert from "@insightfulscience/atomic-react/Alert";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import useFormAction from "@insightfulscience/smart-react/hooks/useFormAction";

import getPlasmidContentMap from "../../providers/getPlasmidContentMap";

const PlasmidInteractiveMap = ({ setID, plasmidID, plasmidFilename }) => {
	const [
		getPlasmidInteractiveMap,
		{ isLoading, result: plasmidInteractiveMap, error },
	] = useFormAction(getPlasmidContentMap);

	useEffect(() => {
		getPlasmidInteractiveMap(setID, plasmidID);
	}, []);

	return (
		<div className="viewport" id="map-content">
			{isLoading && <Paragraph>Loading plasmid interactive map...</Paragraph>}
			{plasmidInteractiveMap && (
				<div
					id="map1"
					className="sg-map-placeholder"
					data-relative-path={`${setID}/${plasmidID}`}
					data-filename={plasmidFilename}
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{ __html: plasmidInteractiveMap }}
				/>
			)}
			{error && (
				<Alert status="error" title="Something went wrong" className="text-left mt-10">
					Failed to fetch plasmid interactive map.
				</Alert>
			)}
		</div>
	);
};

PlasmidInteractiveMap.propTypes = {
	setID: string,
	plasmidID: string,
	plasmidFilename: string,
};

export default PlasmidInteractiveMap;
